import { render, staticRenderFns } from "./AddQualificationData.vue?vue&type=template&id=c0033cb2"
import script from "./AddQualificationData.vue?vue&type=script&lang=js"
export * from "./AddQualificationData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports